module.exports = __webpack_public_path__ + "img/pushtzicon.67f69506.png";